import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import Feather from 'react-native-vector-icons/Feather';

export const Container = styled.View`
  padding: 0 24px;
  padding-bottom: ${RFValue(12)}px;
  margin-bottom: ${RFValue(12)}px;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border};
`;

export const PlacaInfo = styled.View`
  margin-left: ${RFValue(12)}px;
`;

export const PlacaTitle = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const PlacaInfoContainer = styled.View`
  border-style: dashed;
  border-color: ${({theme}) => theme.colors.border};
  padding: ${RFValue(6)}px ${RFValue(12)}px;
  border-width: 2px;
  border-radius: ${RFValue(6)}px;
  margin-top: ${RFValue(10)}px;
`;

export const PlacaInfoText = styled.Text`
  font-size: ${RFValue(11)}px;
  color: ${({theme}) => theme.colors.blue};

  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const PlacaSubtitle = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const PlacaColumn = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const ArrowIcon = styled(Feather)`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.text_dark};
`;

export const PlacaContainer = styled.TouchableOpacity``;

export const PlacaHeader = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ActiveAlertBox = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: ${RFValue(6)}px ${RFValue(12)}px;
  background-color: ${({theme}) => theme.colors.background_black};
  border-radius: ${RFValue(8)}px;
  margin-top: ${RFValue(12)}px;
`;
export const ActiveAlertTitle = styled.Text`
  font-size: ${RFValue(10)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const ActiveDebitSwitch = styled.Switch`
  transform: scale(0.8);
`;
